import * as $ from "jquery";
import CookiesHelper from "../Helpers/helpers.cookies";

export default class CustomerComponent {
    constructor() {
        this.componentSelector = ".customer";
        this.instance = this;
        this.cookies = new CookiesHelper();
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        $('#js-customer-update').off().on('click', function () {
            instance.createCustomer(instance);
        });

        $('#js-backoffice-customer-update').off().on('click', function () {
            instance.createBackOfficeCustomer(instance);
        });

        $('#js-backoffice-customer-delete').off().on('click', function () {
            instance.deleteBackOfficeCustomer(instance);
        });


        $('#js-user-delete').off().on('click', function () {
            instance.deleteUser(instance);
        });
    }

    createCustomer(instance) {
        let customerNumber = $('.customer-form #customernumber').val();
        let email = $('.customer-form #email').val();
        let organisationnumber = $('.customer-form #organisationnumber').val();
        let password = $('.customer-form #password').val();
        let customermarket = $('.customer-form #customermarket').val();

        axios({
            method: 'post',
            url: "/customer/updatecustomer",
            data: { customerNumber: customerNumber, email: email, organisationNumber: organisationnumber, password: password, customerMarket: customermarket }
        }).then(function (response) {
            $('.customer #result').html(response.data);
        }).catch(function (response) {
            console.log(response);
        });
    }

    createBackOfficeCustomer(instance) {
        let name = $('.customer-form #customername').val();
        let password = $('.customer-form #password').val();
        let sellerId = $('.customer-form #customersellerid').val();
        let username = $('.customer-form #customerusername').val();
        let email = $('.customer-form #email').val();

        axios({
            method: 'post',
            url: "/customer/updatebackofficecustomer",
            data: { name: name, password: password, sellerId: sellerId, username: username, email: email }
        }).then(function (response) {
            $('.customer #result').html("Användare " + response.data + " är skapad.");
        }).catch(function (response) {
            console.log(response);
        });
    }

    deleteBackOfficeCustomer(instance) {
        let sellerId = $('.customer-form #customersellerid').val();

        axios({
            method: 'post',
            url: "/customer/RemoveBackofficeCustomer",
            data: { sellerId: sellerId }
        }).then(function (response) {
            $('.customer #result').html("Användare " + response.data + " är borttagen.");
        }).catch(function (response) {
            console.log(response);
        });
    }

    deleteUser(instance) {
        let customerNumber = $('.userdelete-form #customernumber').val();        
        let customermarket = $('.userdelete-form #customermarket').val();

        $('#success').hide();
        $('#error').hide();

        axios({
            method: 'post',
            url: "/customer/deleteuser",
            data: { customerNumber: customerNumber, customerMarket: customermarket }
        }).then(function (response) {
            if (response.data == "False") {
                $('#error').show();
            }
            else {
                $('#success').show();
            }
        }).catch(function (response) {
            console.log(response);
        });
    }
}